import React, { FC, ReactElement } from 'react'
import styles from './LineDivider.module.css'
import className from 'classnames'

const LineDivider: FC<{ className?: string }> = (props): ReactElement => {
	return (
		<div className={className(styles.root, { [(props.className as any)]: !!props.className })}>
			<div className={styles.line} />
		</div>
	)
}

export default LineDivider
